import React, { useId } from "react";

const EMOJI_ART = {
  "🍦": "icecream", "🍿": "movie", "🎬": "movie", "🎟️": "movie",
  "🎮": "game", "🕹️": "game", "🎲": "game", "📱": "screen", "📺": "screen",
  "🌳": "outside", "🏕️": "outside", "⛺": "outside", "📚": "book", "📖": "book",
  "🎁": "gift", "🧸": "gift", "💰": "coins", "💵": "coins", "🌙": "moon", "⚽": "ball",
};
const ICON_ART = {
  "ice-cream-cone": "icecream", film: "movie", "gamepad-2": "game", tablet: "screen",
  trees: "outside", tent: "outside", "book-open": "book", gift: "gift",
  "dollar-sign": "coins", coins: "coins", moon: "moon", "circle-dot": "ball",
};

export function rewardArtType(reward) {
  // A family's own photo or chosen emoji always takes precedence over an icon.
  if (reward?.image_path) return null;
  return reward?.emoji ? EMOJI_ART[reward.emoji] || null : ICON_ART[reward?.icon] || null;
}

export default function RewardArt({ type = "gift", size = 96 }) {
  const id = useId().replace(/:/g, "");
  const cream = `url(#${id}-cream)`;
  const gold = `url(#${id}-gold)`;
  return <svg viewBox="0 0 144 144" width={size} height={size} aria-hidden="true" focusable="false" data-reward-art={type}>
    <defs>
      <linearGradient id={`${id}-cream`} x2=".8" y2="1"><stop stopColor="#fff7ed" /><stop offset="1" stopColor="#fdba74" /></linearGradient>
      <linearGradient id={`${id}-gold`} x2=".8" y2="1"><stop stopColor="#fef08a" /><stop offset=".55" stopColor="#fbbf24" /><stop offset="1" stopColor="#f59e0b" /></linearGradient>
      <linearGradient id={`${id}-sky`} x2=".7" y2="1"><stop stopColor="#DDD6FE" /><stop offset="1" stopColor="#38BDF8" /></linearGradient>
    </defs>
    <ellipse cx="72" cy="127" rx="43" ry="7" fill="#25204B" opacity=".1" />
    <g strokeWidth="3" strokeLinejoin="round" strokeLinecap="round">
      {type === "icecream" && <>
        <path d="m45 68 28 59 28-59" fill={cream} stroke="#b45309" />
        <path d="m54 84 33 13m-25 5 18 7m11-31-26 32m16-38-24 22" stroke="#d97706" strokeWidth="2" />
        <path d="M38 58c-2-13 8-21 19-20-1-13 23-24 32-6 14-2 23 12 16 22 15 9 9 25-3 27-9 1-13-5-15-10-8 12-25 12-29 0-18 16-33-4-20-13Z" fill="#fda4af" stroke="#be123c" />
        <path d="m49 52 5-3m18-11 5 2m14 18 5-2m-27 5 3-4" stroke="#fff1f2" strokeWidth="5" />
        <circle cx="78" cy="22" r="9" fill="#fb7185" stroke="#be123c" /><path d="M78 13q0-8 7-9" fill="none" stroke="#5B21B6" />
      </>}
      {type === "movie" && <>
        <path d="m34 62 9 62h60l9-62Z" fill="#fff7ed" stroke="#9f1239" />
        <path d="m46 65 5 53m17-53v53m18-53-3 53m18-53-5 53" stroke="#fb7185" strokeWidth="9" />
        <path d="M28 61c-6-11 2-20 12-19-4-13 10-20 20-12 4-16 22-16 28-4 15-6 25 3 22 15 17 0 20 16 9 23Z" fill="#fef3c7" stroke="#d97706" />
        <path d="m44 44 4 6m20-12-4 6m24-3 7 5m10 7 1 5" stroke="#fbbf24" strokeWidth="4" />
        <circle cx="74" cy="90" r="16" fill={gold} stroke="#b45309" /><path d="m70 82 12 8-12 8Z" fill="#92400e" stroke="none" />
      </>}
      {type === "game" && <>
        <path d="M41 48c-19-1-32 51-20 61 11 9 21-12 32-12h37c12 0 23 21 34 11 12-11-4-62-21-61Z" fill={`url(#${id}-sky)`} stroke="#4C1D95" />
        <path d="M42 60v27m-13-13h27" stroke="#4C1D95" strokeWidth="8" />
        <circle cx="100" cy="66" r="7" fill="#fbbf24" stroke="#92400e" /><circle cx="113" cy="81" r="7" fill="#fb7185" stroke="#9f1239" />
        <path d="M65 79h9m-4-33V30q0-12 16-10" stroke="#475569" fill="none" /><path d="M34 52h49" stroke="white" opacity=".7" />
      </>}
      {type === "screen" && <>
        <rect x="30" y="17" width="84" height="110" rx="14" fill="#334155" stroke="#0f172a" />
        <rect x="37" y="25" width="70" height="84" rx="7" fill="#a5b4fc" />
        <path d="m37 90 26-29 18 18 26-34v58H37Z" fill="#6366f1" stroke="none" /><circle cx="83" cy="46" r="10" fill="#fef08a" stroke="none" />
        <path d="M48 32h21" stroke="white" opacity=".6" /><circle cx="72" cy="118" r="3" fill="#cbd5e1" stroke="none" />
      </>}
      {type === "outside" && <>
        <path d="M21 107q50-24 104 0l-6 18H28Z" fill="#C4B5FD" stroke="#5B21B6" />
        <path d="M43 102V52m63 49V63" stroke="#92400e" strokeWidth="6" /><path d="m43 13-28 60h56Zm62 21-21 48h43Z" fill="#A78BFA" stroke="#5B21B6" />
        <path d="m75 67-31 53h63Z" fill={gold} stroke="#b45309" /><path d="m75 67 3 53H57Z" fill="#fff7ed" stroke="#b45309" />
        <circle cx="93" cy="22" r="11" fill="#fde68a" stroke="none" />
      </>}
      {type === "book" && <>
        <path d="M24 33q28-10 48 5 19-15 48-5v84q-27-10-48 6-20-16-48-6Z" fill="#a78bfa" stroke="#5b21b6" />
        <path d="M32 27q22-6 40 8 18-14 40-8v80q-23-4-40 10-17-14-40-10Z" fill="#fff7ed" stroke="#7c3aed" />
        <path d="M72 35v82M42 47l18 6m-18 9 18 6m-18 9 18 6m24-30 18-6m-18 21 18-6m-18 21 18-6" fill="none" stroke="#c4b5fd" />
        <path d="M89 25v33l9-6 8 3V25" fill="#fbbf24" stroke="none" />
      </>}
      {type === "gift" && <>
        <path d="M32 62h80v59H32Z" fill="#a78bfa" stroke="#5b21b6" /><rect x="25" y="45" width="94" height="25" rx="7" fill="#c4b5fd" stroke="#5b21b6" />
        <path d="M61 46h22v75H61Z" fill={gold} stroke="#b45309" />
        <path d="M72 45c-46 2-32-46-11-29 11 9 11 29 11 29s1-25 16-30c26-9 31 30-16 30Z" fill="#fde68a" stroke="#b45309" />
        <path d="M36 53h16m-11 24v28" stroke="white" opacity=".6" />
      </>}
      {type === "coins" && <>
        {[111, 99, 87].map(y => <g key={y}><path d={`M25 ${y-9}v11c0 13 63 13 63 0v-11`} fill="#f59e0b" stroke="#b45309" /><ellipse cx="56" cy={y-9} rx="31" ry="10" fill={gold} stroke="#b45309" /></g>)}
        <circle cx="91" cy="60" r="31" fill={gold} stroke="#b45309" /><circle cx="91" cy="60" r="24" fill="none" stroke="#fef3c7" /><path d="m93 43-14 20h11l-1 14 15-22H93Z" fill="#b45309" stroke="none" />
      </>}
      {type === "moon" && <><path d="M95 20C25-1 7 104 75 121c28 7 45-12 48-28-56 16-85-45-28-73Z" fill={gold} stroke="#b45309" /><path d="m100 34 5 12 14 2-10 9 3 13-12-7-12 7 3-13-10-9 14-2Z" fill="#a5b4fc" stroke="#6366f1" /><circle cx="49" cy="76" r="3" fill="#92400e" /><path d="M58 91q8 8 15 1" fill="none" stroke="#92400e" /></>}
      {type === "ball" && <><circle cx="72" cy="74" r="47" fill="#f8fafc" stroke="#475569" /><path d="m72 53 20 14-8 23H60l-8-23Z" fill="#334155" /><path d="m52 67-24-6m32 29-13 23m37-23 13 23m-5-46 24-6M72 53V28" stroke="#64748b" /><path d="m37 48 17-14m43 1 11 13" stroke="#38BDF8" strokeWidth="8" /></>}
    </g>
    <path d="m18 24 3-8 3 8 8 3-8 3-3 8-3-8-8-3Z" fill="#fbbf24" />
    <circle cx="125" cy="35" r="3" fill="#a78bfa" />
  </svg>;
}
